'use client';

import { createContext, useContext } from 'react';
import type { Menu as MenuPrimitive } from '@base-ui/react';

/** Why the menu closed, as Base UI reports it on `onOpenChange`. */
export type PopoverMenuCloseReason = MenuPrimitive.Root.ChangeEventReason;

/**
 * Exit animation control shared by the root and the rows that close the menu.
 * A checkbox or radio row with `closeOnClick` changes its tick as the popup
 * leaves, which reads as a flicker, so that row calls `skipExitAnimation` and
 * the popup disappears at once. Every other close animates.
 */
export type PopoverMenuRootContextValue = {
  instantClose: boolean;
  skipExitAnimation: () => void;
};

const PopoverMenuRootContext = createContext<PopoverMenuRootContextValue>({
  instantClose: false,
  skipExitAnimation: () => {},
});

export const PopoverMenuRootProvider = PopoverMenuRootContext.Provider;

export const usePopoverMenuRootContext = () => useContext(PopoverMenuRootContext);
